module.exports = __webpack_public_path__ + "static/media/Background_10.c4ea3816.svg";